import { createRouter, createWebHistory } from 'vue-router';
import Home from '@/views/Home.vue';
import CourseDetail from '@/views/CourseDetail.vue';
import UserProfile from '@/views/UserProfile.vue';
import About from '@/views/About.vue';
import Contact from '@/views/Contact.vue';
// import VideoList from './VideoList.vue';
import VideoPlayer from '@/views/VideoPlayer.vue';


const routes = [
  {
    path: '/',
    name: 'Home',
    component: Home,
  },
  {
    path: '/course/:id',
    name: 'CourseDetail',
    component: CourseDetail,
    props: true,
  },
  {
    path: '/user-profile',
    name: 'UserProfile',
    component: UserProfile,
  },
  {
    path: '/home',
    name: 'home',
    component: Home,
  },
  {
    path: '/about',
    name: 'about',
    component: About,
  },
  {
    path: '/contact',
    name: 'contact',
    component: Contact,
  },
  {
    path: '/player/:id',
    name: 'VideoPlayer',
    component: VideoPlayer,
    props: true
  },
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
});

export default router;
